import { connect } from 'react-redux';
import {
    selectCanOrder,
    selectIsSubmitOrderPending,
    selectOrderContext,
    submitOrder,
    selectSubmitOrderError,
    clearSubmitErrorMessage,
    selectExternalPayment,
    selectLastBillStatus,
    selectLastBillSummary,
    repayment,
    cancelOrder,
    selectCancelOrderError,
    clearCancelOrderErrorMessage,
    selectRepaymentError,
    clearRepaymentErrorMessage
} from 'src/modules/Order';

const mapDispatchToProps = {
    submitOrder,
    clearSubmitErrorMessage,
    clearCancelOrderErrorMessage,
    repayment,
    cancelOrder,
    clearRepaymentErrorMessage
};

const mapStateToProps = (state) => ({
    context: selectOrderContext(state),
    isSubmitOrderPending: selectIsSubmitOrderPending(state),
    canOrder: selectCanOrder(state),
    error: selectSubmitOrderError(state),
    payment: selectExternalPayment(state),
    lastBillStatus: selectLastBillStatus(state),
    lastBillSummary: selectLastBillSummary(state),
    cancelOrderError: selectCancelOrderError(state),
    repaymentError: selectRepaymentError(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
